import React, { useEffect, useState } from "react";
import HeaderAction from "../components/HeaderAction";
import styled from "styled-components";
import Tab from "../components/Tab";
import ListProduct from "../components/ListProduct";
import { ID_PRIZE } from "../components/DefineData";
import iconBg1 from "../../../../assets/images/Event-2026/bg-icon-01.png";
import iconBg2 from "../../../../assets/images/Event-2026/bg-icon-2.png";
import { getCookie, getDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import { curStateMiniGame } from "../../../../Redux/selector";
import { getDataAwardListMiniGame, useDispatch, useSelector } from "@pages/Events/MiniGame/store";
import { useParams } from "react-router-dom";
import { useNavigate } from "@hooks/useNavigate";
import bgTakePrize from "../../../../assets/images/Mini-Game/bg-take-prize-web-x2.png";
import bgTakePrizeThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/bg-take-prize-thadingyut-2025-theme.png";
import bgTakePrizeThadingyutPc from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/bg-take-prize-thadingyut-2025-theme-pc.png";
import bgTakePrizeNewYear from "../../../../assets/images/Mini-Game/new-year-2025/bg-take-prize.png";

import bgTake from "../../../../assets/images/Event-2026/bg-take-prize.png";
import DetailProduct from "../components/DetailProduct";
import _ from "lodash";
import {
  getDataPieceCollectedMiniGame,
  setDataPopupError,
  setOpenPopupPiece,
} from "../../../../Redux/futures/mini-game/action";
import ModalNotifycation from "../../../../components/Modal/ModalNotifycation";
import { useTranslation } from "react-i18next";
import PopupCongratulaPuzzle from "../components/PopupFooter/PopupCongratulaPuzzle";
import {
  INVITE_MARQUEE_END_DATE,
  INVITE_MARQUEE_START_DATE,
  // IS_EVENT_THADINGYUT_2025_THEME,
  TYPE_DETAIL_PUZZLE_PIECE,
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../helper/const";
import PopupCongPiece from "../components/PopupFooter/PopupCongPiece";
import { mediaQueryPoint, useMediaQuery } from "../../../../utils/hooks";
import moment from "moment";
import InviteMarquee from "../components/InviteMarquee";
import PATH from "../../../../config/PATH";
import { ID_TAB_MINI_GAME } from "../../../../helper/const";

export default function TakePrize({
  newYearAudioRef,
}
) {
  const { awardId } = useParams();
  const itemProductActive = awardId;
  const [dataAwardActive, setDataAwardActive] = useState([]);
  const [isRunout, setIsRunout] = useState(null);
  const dataMiniGame = useSelector(curStateMiniGame);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isTake, setIsTake] = useState(true);
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);
  const [showInviteMarquee, setShowInviteMarquee] = React.useState(false);
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  useEffect(() => {
    const checkAndUpdateMarquee = () => {
      const now = moment();
      const shouldShow = now.isBetween(
        INVITE_MARQUEE_START_DATE,
        INVITE_MARQUEE_END_DATE
      );
      setShowInviteMarquee(shouldShow);
    };

    checkAndUpdateMarquee();

    const interval = setInterval(checkAndUpdateMarquee, 30000);

    return () => clearInterval(interval);
  }, []);

  const bgTakePrizeThadingyutTheme = isMobile
    ? bgTakePrizeThadingyut
    : bgTakePrizeThadingyutPc;

  const setItemProductActive = (id) => {
    navigate(
      `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.takePrize}/${id}`
    );
  };

  useEffect(() => {
    if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
      return;
    }
    if (!awardId) {
      const dataSort = dataMiniGame.dataAwardListMini.sort(
        (a, b) => Number(a.rank) - Number(b.rank)
      );
      setItemProductActive(dataSort[0]?.id);
    }
  }, [dataMiniGame.dataAwardListMini]);

  // useEffect(() => {
  //   // dispatch(getDataPieceCollectedMiniGame(itemProductActive))
  // },[itemProductActive])

  const handleGetDataCollected = async () => {
    const dataApi = await getDataApi(API_PATH.miniGamePieceCollected, {
      award_id: itemProductActive,
    });
    console.log("itemProductActive:", itemProductActive); // ← thêm dòng này

    setDataAwardActive(dataApi?.data);
    setIsRunout(dataApi?.is_runout);

    dispatch(getDataAwardListMiniGame());
  };

  useEffect(() => {
    handleGetDataCollected();
  }, [itemProductActive]);

  const handleShowDetailItem = (dataPrize) => {

    let awardName = "";
    const dataAwardListMini = dataMiniGame.dataAwardListMini || [];
    dataAwardListMini.forEach((item) => {
      if (+item.id === +dataPrize.minigame_award_id) {
        awardName = item.name;
      }
    });

    return dispatch(
      setOpenPopupPiece({
        isShowPopupPiece: true,
        type: TYPE_DETAIL_PUZZLE_PIECE,
        data: { ...dataPrize, awardName },
        turn: 0,
      })
    );
  };

  const handleClosePopupError = () => {
    dispatch(
      setDataPopupError({
        isOpen: false,
        message: "",
      })
    );
  };

  const isMobileMd = useMediaQuery(`(min-width: ${mediaQueryPoint.md}px)`);
  const isDesktop = useMediaQuery(`(max-width: 1050px)`);
  let itemShow = 4.5;
  if (isDesktop) {
    itemShow = 3.5;
  }

  return (
    <>
      {dataMiniGame?.dataPopupErrorMini?.isOpen ? (
        <ModalNotifycation
          open={true}
          handleCancel={handleClosePopupError}
          title={t("error")}
          message={
            dataMiniGame?.dataPopupErrorMini?.message ||
            "There was a problem while processing. Please try again."
          }
          isContainer
        />
      ) : null}
      {dataMiniGame.popupPiece.isShowPopupPiece ? (
        <PopupCongPiece
          isOpen={dataMiniGame.popupPiece.isShowPopupPiece}
          type={dataMiniGame.popupPiece.type}
          data={dataMiniGame.popupPiece.data}
          onCancel={() =>
            dispatch(
              setOpenPopupPiece({
                isShowPopupPiece: false,
                type: null,
                data: null,
              })
            )
          }
        />
      ) : null}
      <Div
        bg={
          IS_EVENT_THADINGYUT_2025_THEME
            ? bgTakePrizeThadingyutTheme
            : IS_EVENT_NEW_YEAR_2025_THEME
              ? bgTakePrizeNewYear
              : bgTakePrize
        }
        className={`${IS_EVENT_THADINGYUT_2025_THEME
          ? "thadingyut-theme"
          : IS_EVENT_NEW_YEAR_2025_THEME
            ? "new-year-25-theme"
            : ""
          }`}
      >
        <Container className='container-thingyan container-minigame'>
          <div className='thingyan-home-header'>
            {/* {!IS_EVENT_THADINGYUT_2025_THEME &&
              !IS_EVENT_NEW_YEAR_2025_THEME && (
                <>
                  <img src={iconBg1} alt='' className='icon-bg-web1' />
                  <img src={iconBg2} alt='' className='icon-bg-web2' />
                </>
              )} */}
            <div className='header-take-prize'>
              <HeaderAction newYearAudioRef={newYearAudioRef} />
            </div>
            <Tab itemProductActive={itemProductActive} />
            <ListProduct
              setItemProductActive={setItemProductActive}
              itemProductActive={itemProductActive}
              itemShow={itemShow}
            />
            {/* <DetailProduct
              itemProductActive={itemProductActive}
              dataAwardActive={dataAwardActive}
              setDataAwardActive={setDataAwardActive}
              handleShowDetailItem={handleShowDetailItem}
              isRunout={isRunout}
              setIsTake={setIsTake}
            /> */}
            <DetailProduct
              itemProductActive={itemProductActive}
              dataAwardActive={dataAwardActive}
              setDataAwardActive={setDataAwardActive}
              handleShowDetailItem={handleShowDetailItem}
              isRunout={isRunout}
              setIsTake={setIsTake}
              refreshDataDetail={handleGetDataCollected}
            />
          </div>
        </Container>
        {showInviteMarquee && <InviteMarquee />}
      </Div>
      {dataMiniGame.popupPuzzle.isShow ? (
        <PopupCongratulaPuzzle isOpen={dataMiniGame.popupPuzzle.isShow} />
      ) : null}
    </>
  );
}
const Div = styled.div`
  /* new */
  .container-thingyan .thingyan-home-header {
    background-image: url(${bgTake}) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
  }
  /* end new */
  .img-filter-event__2025 {
    filter: drop-shadow(0px 0px 1px white) drop-shadow(0px 0px 1px white)
      drop-shadow(0px 0px 2px white);
  }

  .group_detail{
    padding-bottom: 150px;
  }
  .group_detail_prod {
      background: linear-gradient(180deg, #777AFF 0%, #3142DC 94.38%);
      border: 8px solid #3142DC;
      border-radius: 16px;
      width: 100%;
      max-width: 510px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto;

      @media (max-width: 768px) {
        width: calc(100% - 40px);
        margin-bottom: 135px;
        /* min-height: 425px; */
      }
  }

  .text-default {
    -webkit-text-stroke: inherit !important;
    font-size: 26px !important;
  }

  &.thadingyut-theme {
    .container-thingyan .thingyan-home-header {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;

      /* @media (min-width: 768px) and (max-width: 1400px) {
        background-size: 165% 100%;
      }

      @media (min-width: 1400px) and (max-width: 1600px) {
        background-size: 145% 100%;
      } */
    }
  }

  &.new-year-25-theme {
    .container-thingyan .thingyan-home-header {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }

    @media (min-width: 768px) and (max-width: 1400px) {
      background-size: 165% 100%;
    }

    @media (min-width: 1400px) and (max-width: 1600px) {
      background-size: 145% 100%;
    }
  }
`;

const Container = styled.div`
  .header-take-prize {
    padding-top: 18px;
    margin-bottom: 30px;
  }

  .content-take-prize-minigame {
    background-color: rgba(0, 0, 0, 0.4);
    padding: 10px;
    border-radius: 40px;
    color: white;
    font-style: italic;
    text-align: center;
    margin: 0 85px;
    margin-bottom: 20px;

    @media (max-width: 1400px) {
      margin: 0 36px;
      margin-bottom: 20px;
    }

    @media (max-width: 440px) {
      margin: 0 8px;
      margin-bottom: 20px;
    }
  }

  .thingyan-home-header {
    overflow-y: hidden;
  }

  @media (max-width: 992px) {
    .title-prize{
      font-size: 11px;
    }
  }

  @media (max-width: 576px) {
    .header-take-prize {
      padding-top: 10px;
      margin-bottom: 20px;
    }
  }

  @media (min-width: 1400px) {
    .header-take-prize {
      padding-top: 25px;
      padding-left: 22px;
      padding-right: 22px;
    }
  }
`;


